var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"content md"},[_c('div',{staticClass:"dharma-assembly-loading"},[_c('a-spin',{attrs:{"tip":"加载中"}})],1)]):_c('buddhism-order',{attrs:{"temp":_vm.temp}})
}
var staticRenderFns = []

export { render, staticRenderFns }